
export const ClientAction =
{
    DECONTAMINATION: {
        UPDATE_ORDER_ITEM_MEASUREMENT: 'update_decon_order_item_measurement',
        REMOVE_ORDER_ITEM_MEASUREMENT: 'remove_decon_order_item_measurement',
        SET_ORDER_ITEM_COMPLETED : 'set_decon_order_item_completed',
        SET_ORDER_COMPLETED : 'set_decon_order_completed',
        ADD_ORDER_IMAGE: 'add_decon_order_image',
        REMOVE_ORDER_IMAGE: 'remove_decon_order_image',
        ADD_ORDER_ITEM: 'add_decon_order_item',

        REMOVE_ORDER_ITEM_CLEANSING_INSTANCE: 'remove_decon_order_item_cleansing_instance',
        UPDATE_ORDER_ITEM_CLEANSING_INSTANCE: 'update_decon_order_item_cleansing_instance',

    },

    PACKAGE_TRACKING: {
        RECEIVE_PACKAGE: 'pt_receive_package',
        RECEIVE_DELIVERY_NOTE_ITEM: 'pt_receive_delivery_note_item',
        SHELVE_PACKAGE: 'pt_shelve_package',
        COLLECT_FOR_DELIVERY: 'pt_collect_for_delivery',
        DROP_PACKAGE: 'pt_drop_package'
    }
}